import React from 'react';
import { useAuth } from '@providers';
import { GuestLayout } from './GuestLayout';
import { StandardLayout } from './StandardLayout';

/**
 * AIDEV-NOTE: AdaptiveLayout - Dynamically selects layout based on auth state
 * ============================================================================
 * This wrapper component chooses between GuestLayout and StandardLayout
 * based on the user's authentication state.
 *
 * ARCHITECTURE:
 * - For authenticated users: Renders StandardLayout with full features
 * - For guests: Renders GuestLayout with login prompts for protected actions
 *
 * Used for routes that are accessible by both guests and authenticated users
 * (e.g., /home, /events).
 */
export const AdaptiveLayout: React.FC = () => {
  const { showAuthenticatedUI } = useAuth();

  // AIDEV-NOTE: Simple conditional render - no loading state needed
  // Auth state is already resolved by the time routes render
  if (showAuthenticatedUI) {
    return <StandardLayout />;
  }

  return <GuestLayout />;
};
